/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SEARCH_WORD,
    SEARCH_DETAIL_LAYER } from '../../libs/reducer'
import OutSide from './outSide'

const DetailSearch = ({ onSearch }) => {
    const { searchWord, searchDetailLayer } = useSelector(state => state.search)
    const [preview, setPreview] = useState('')
    const [searchBase, setSearchBase] = useState('')
    const [searchInclude, setSearchInclude] = useState('')
    const [searchExact, setSearchExact] = useState('')
    const [searchExclude, setSearchExclude] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        if (searchDetailLayer) {
            setDefaultKeyword()
        } else {
            resetForm()
        }
    }, [searchDetailLayer])

    const setDefaultKeyword = () => {
        let keyWord = `${searchWord} `

        const isInclude = / \+/.test(keyWord)
        const isExact = / "/.test(keyWord)
        const isExclude = / -/.test(keyWord)

        let base = ''
        let include = ''
        let exact = ''
        let exclude = ''

        if (isInclude) {
            include = keyWord.split(' +').pop().split(' ')[0]
            keyWord = keyWord.split(' +')[0] + ' ' + keyWord.split(' +').pop().split(' ').slice(1, keyWord.length).join(' ')
        }
        if (isExact) {
            exact = keyWord.split(' "').pop().split('"')[0]
            keyWord = keyWord.split(' "')[0] + ' ' + keyWord.split(' "').pop().split('"').pop()
        }
        if (isExclude) {
            exclude = keyWord.split(' -').pop().split(' ')[0]
            keyWord = keyWord.split(' -')[0] + ' ' + keyWord.split(' -').pop().split(' ').slice(1, keyWord.length).join(' ')
        }
        base = keyWord.trim()

        let previewWord = ''
        if (base.length > 0)    previewWord += `${base}`
        if (include.length > 0) previewWord += ` +${include}`
        if (exact.length > 0)   previewWord += ` "${exact}"`
        if (exclude.length > 0) previewWord += ` -${exclude}`

        setPreview(previewWord.trim())
        setSearchBase(base)
        setSearchInclude(include)
        setSearchExact(exact)
        setSearchExclude(exclude)
    }
    const errorTxt1 = txt => {
        if (/"|\/|\|/.exec(txt)) {
            alert('"/| 는 입력하실 수 없습니다.')
            return false
        }
        return true
    }
    const errorTxt2 = txt => {
        if (/\+|-|\|/.exec(txt)) {
            alert('+-| 는 입력하실 수 없습니다.')
            return false
        }
        return true
    }
    const onChangeBase = e => {
        const { value } = e.target
        if (!errorTxt2(value)) return
        setSearchBase(value)
        changePreview('base', value)
    }
    const onChangeInclude = e => {
        const { value } = e.target
        if (!errorTxt1(value)) return
        setSearchInclude(value)
        changePreview('include', value)
    }
    const onChangeExact = e => {
        const { value } = e.target
        if (!errorTxt1(value)) return
        setSearchExact(value)
        changePreview('exact', value)
    }
    const onChangeExclude = e => {
        const { value } = e.target
        if (!errorTxt1(value)) return
        setSearchExclude(value)
        changePreview('exclude', value)
    }
    const changePreview = (type, txt = '') => {
        const word = txt.trim()
        const typeObj = {
            base: searchBase.trim(),
            include: searchInclude.trim(),
            exact: searchExact.trim(),
            exclude: searchExclude.trim()
        }
        if (type) typeObj[type] = word

        const { base, include, exact, exclude } = typeObj
        let searchWord = ''

        if (base.length > 0)    searchWord += `${base}`
        if (include.length > 0) searchWord += ` +${include}`
        if (exact.length > 0)   searchWord += ` "${exact}"`
        if (exclude.length > 0) searchWord += ` -${exclude}`

        setPreview(searchWord.trim())
    }
    const resetForm = () => {
        setPreview('')
        setSearchBase('')
        setSearchInclude('')
        setSearchExact('')
        setSearchExclude('')
    }

    const onSubmit = () => {
        if (!searchBase) {
            alert('기본 검색어를 입력해 주세요.')
            return
        }
        dispatch({
            type: SEARCH_WORD,
            data: preview
        })
        detailLayerControl(false)() // 검색시 레이어 닫기
        onSearch(preview)
    }

    const detailLayerControl = data => () => {
        dispatch({
            type: SEARCH_DETAIL_LAYER,
            data: data === 'auto' ? !searchDetailLayer : data
        })
    }

    const onKeyDown = useCallback(e => {
        if (e.key === 'Enter') {
            onSubmit()
            return
        } else if (e.key === 'Escape') {
            detailLayerControl(false)()
            return
        }
    })

    return (
        <OutSide action={detailLayerControl(false)}>
            <div className="header_detail_search">
                <button
                    className={`search_detail_button ${searchDetailLayer ? 'active' : ''}`}
                    onClick={detailLayerControl('auto')}
                >
                    상세검색
                </button>
                {searchDetailLayer && (
                    <div className="search_detail_layer">
                        <h4>상세검색</h4>
                        <div className="field">
                            <div className="column">
                                <p className="preview">{preview}</p>
                                <table className="tbl_detail">
                                    <colgroup>
                                        <col style={{ width: '140px' }} />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr className="top top1">
                                            <td className="th">
                                                <label className="stit" htmlFor="lb_srh_basis">
                                                    <strong>기본검색</strong>
                                                </label>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="lb_srh_basis"
                                                    className="srh_input _base"
                                                    value={searchBase}
                                                    maxLength="50"
                                                    onChange={onChangeBase}
                                                    onKeyDown={onKeyDown}
                                                />
                                            </td>
                                        </tr>
                                        <tr className="top">
                                            <td className="th">
                                                <span className="stit">
                                                    <strong>상세검색</strong>
                                                </span>
                                            </td>
                                            <td>
                                                <p className="dsc">
                                                    <strong className="bright">*</strong>
                                                    기본 검색의 결과 범위를 줄이고자 할 때 사용합니다.
                                                    <br />
                                                    &nbsp;&nbsp;여러개의 단어를 입력할 때는<span className="bright">쉼표 (,)</span>로 구분해서 입력하세요.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="th">
                                                <label htmlFor="lb_srh_include">결과내 재검색 단어 (+)</label>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="lb_srh_include"
                                                    className="srh_input _include"
                                                    maxLength="50"
                                                    value={searchInclude}
                                                    onChange={onChangeInclude}
                                                    onKeyDown={onKeyDown}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="th">
                                                <label htmlFor="lb_srh_exact">정확히 일치하는 문장 (“”)</label>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="lb_srh_exact"
                                                    className="srh_input _exact"
                                                    maxLength="50"
                                                    value={searchExact}
                                                    onChange={onChangeExact}
                                                    onKeyDown={onKeyDown}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="th">
                                                <label htmlFor="lb_srh_exclude">제외하는 단어 (-)</label>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    id="lb_srh_exclude"
                                                    className="srh_input _exclude"
                                                    maxLength="50"
                                                    value={searchExclude}
                                                    onChange={onChangeExclude}
                                                    onKeyDown={onKeyDown}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p className="or_none">
                                    <strong className="bright">*</strong> 행복쇼핑내에선 OR 검색어는 제공하지 않습니다.
                                </p>
                                <div className="btn_group">
                                    <button type="button" className="refresh" onClick={resetForm}>
                                        <i className="icon-uniE9F9" /> 초기화
                                    </button>
                                    <button type="button" className="cancel" onClick={detailLayerControl(false)}>닫기</button>
                                    <button type="button" className="confirm" onClick={onSubmit}>검색</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </OutSide>
    )
}

export default DetailSearch



// WEBPACK FOOTER //
// ./src/header/component/search/detail_search.js